import { ApiMeUser, PaidUser, useApp, UserType } from 'src/models/auth';
import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { GET_ME_INFO } from 'src/models/auth/queries';
import { isEqual } from 'lodash';

export interface ApiMeResponse {
  getMe: {
    account: ApiMeUser | null;
  };
}
export interface MeResponse {
  data?: PaidUser | null;
}
export function useMe(): MeResponse {
  const { permission, authUser, setResult, user } = useApp();
  const paidQuery = useQuery<ApiMeResponse>(GET_ME_INFO, {
    skip: permission === UserType.Free && !!authUser,
    onCompleted: ({ getMe: { account } }) => {
      if (!!account) {
        const newUser = new PaidUser(account);
        if (!isEqual(user, newUser)) {
          setResult(result => ({
            ...result,
            user: newUser
          }));
        }
      }
    }
  });

  const paidUser = useMemo(
    () =>
      permission !== UserType.Free && authUser && paidQuery.data
        ? paidQuery.data.getMe.account
          ? new PaidUser(paidQuery.data.getMe.account)
          : undefined
        : undefined,
    [authUser, permission, paidQuery.data]
  );

  return useMemo(
    () => ({
      data: paidUser
    }),
    [paidUser]
  );
}

export default useMe;
